import { API, axiosInstance } from "lib";
import { constant } from 'constants/constant';

export const getSeriesListData = (data = {}, name) => {
  return axiosInstance
    .post(API.FIRM + 'get_vr_series', data) // 'get_billraise_series'
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const addNewSeries = (data = {}, name) => {
  return axiosInstance
    .post(API.FIRM + 'add_vr_series', data) // 'add_billraise_series'
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const setSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.FIRM + 'set_vr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getCurrentSeriesNumber = (data = {}) => {
  return axiosInstance
    .post(API.FIRM + "get_vr_number", data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.FIRM + 'update_vr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const deleteSeriesData = (data = {}) => {
  console.log('data', data)
  return axiosInstance
    .post(API.FIRM + 'delete_vr_series', data) //  'delete_billraise_series'
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};